import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        eyebrow="Explore"
        title="分类快捷入口"
        description="按类型、年代与地区快速找到你想了解的作品。"
        linkTo="/category"
        linkLabel="进入电影分类"
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/category?tag=${encodeURIComponent(category.tag)}`}
            className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full h-28 md:h-32 overflow-hidden bg-background-200">
              <img
                src={category.cover}
                alt={`${category.name} 分类`}
                title={`${category.name} - 电影分类`}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
            </div>
            <div className="p-3">
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                {category.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {category.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}